import { render, staticRenderFns } from "./TabelaDeSubitens.vue?vue&type=template&id=d67b3c5a&scoped=true"
import script from "./TabelaDeSubitens.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeSubitens.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeSubitens.vue?vue&type=style&index=0&id=d67b3c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67b3c5a",
  null
  
)

export default component.exports